// extracted by mini-css-extract-plugin
export default {"container":"Contact_container__MwkDN","main":"Contact_main__+vp7E","top":"Contact_top__jahhO"};